// Prescription reserve

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, email, sameAs, minLength, maxLength } from 'vuelidate/lib/validators';
import axios from 'axios';

Vue.use(Vuelidate);

const prescriptioReserve = document.querySelector('#prescriptioReserve');
if (prescriptioReserve) {
  new Vue({
    el: '#prescriptioReserve',
    data: () => ({
      form: {
        prescriptions: [
          {
            number: ''
          }
        ],
        name: '',
        lastname: '',
        email: '',
        phone: '',
        pharmacy: '',
        recipient: '',
        isConditionsAgreement: false,
      },
      pharmacies: null,
      pharmacy: ''
    }),
    validations: {
      form: {
        prescriptions: {
          $each: {
            number: {
              required,
              minLength: minLength(12),
              maxLength: maxLength(12),
            }
          }
        },
        name: { required },
        lastname: { required },
        email: { required, email },
        phone: { required },
        pharmacy: { required },
        isConditionsAgreement: { sameAs: sameAs( () => true )}
      }
    },
    mounted() {
      this.getPharmacies()
    },
    computed: {
      selectedPharmacyID() {
        return this.form.pharmacy
      }
    },
    methods: {
      addPrescription() {
        this.form.prescriptions.push({number: ''})
      },
      removePrescription() {
        this.form.prescriptions.pop()
      },
      onSubmit() {
        this.$v.form.$touch()
        if (!this.$v.form.$error) {
          this.$refs.prescriptionReserveForm.submit()
        }
      },
      getPharmacies() {
        const url = `${API_HOST}/Facility/GetPharmacies`;
        axios
          .get(url)
          .then(response => {
            this.pharmacies = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      localDays(days) {
        let sortedDays = []
        let order = [1, 2, 3, 4, 5, 6, 0]
        order.map(item => {
          switch (days[item].label) {
          case 'Monday':
            days[item].label = 'Po';
            break;
          case 'Tuesday':
            days[item].label = 'Út';
            break;
          case "Wednesday":
            days[item].label = 'St';
            break;
          case 'Thursday':
            days[item].label = 'Čt';
            break;
          case 'Friday':
            days[item].label = 'Pá';
            break;
          case 'Saturday':
            days[item].label = 'So';
            break;
          case 'Sunday':
            days[item].label = 'Ne';
            break;
          default:
            break;
          }
          sortedDays.push(days[item])
        });
        return sortedDays
      }
    },
    watch: {
      selectedPharmacyID: function (id) {
        this.pharmacy = this.pharmacies.find(item => item.id === id)
      }
    }
  });
}
